// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1ruVK","content":"LayoutSettings_content__3Sj7i"};